import { SponsoredBy as SponsoredByModel } from 'models/SponsoredBy';
import { ProductCard } from 'components/Shared/Product/themes/BGH/productCard';
import { NotifyLink } from 'components/Shared/NotifyLink';
import Image from 'components/Shared/Image';
import { Section } from 'components/Section';
import { transparentize } from '../../utils';
import styles from '../../styles.scss';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import {
  getSponsoredListName,
  mapProductListViewProductToGtm
} from 'store/googleTagManager/events/utils';
import { GtmSelectItem, GtmViewListItem } from 'store/googleTagManager/actions';
import { useDispatch } from 'react-redux';
import { TrackedElement, useIntersectionObserver } from 'hooks/useIntersectionObserver';

const secondaryColorOpacity = 0.17;

const logoDimensions = {
  width: 166,
  height: 32
};

const MOBILE_WIDTH = 98;
const DESKTOP_WIDTH = 118;
const IMAGE_MARGIN = 2;

const pictureDimensions = {
  width: DESKTOP_WIDTH + IMAGE_MARGIN,
  height: DESKTOP_WIDTH + IMAGE_MARGIN
};

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

interface MergedProps extends SponsoredByModel {
  isBGH: boolean;
}

export const SponsoredBy = ({ title, products, color, brandImage, ticket, url }: MergedProps) => {
  const reduxDispatch = useDispatch();

  const { setElementRef } = useIntersectionObserver({
    onBatchVisible: handleElementsVisible
  });

  function handleElementsVisible(elements: TrackedElement<ProductlistViewProduct>[]) {
    const items = elements.map(element => {
      const viewedProduct = element.payload;
      const productIndex = products.indexOf(viewedProduct);

      return mapProductListViewProductToGtm({
        product: viewedProduct,
        indexInList: productIndex,
        listName: getSponsoredListName(title)
      });
    });

    reduxDispatch(GtmViewListItem({ gtmItemProducts: items }));
  }

  const gtmOnProductClick = (product: ProductlistViewProduct, index: number) => {
    const gtmItemProduct = mapProductListViewProductToGtm({
      product,
      indexInList: index,
      listName: getSponsoredListName(title)
    });

    reduxDispatch(GtmSelectItem({ gtmItemProduct }));
  };

  return (
    <>
      {products.length ? (
        <div
          className={styles.sponsoredBy}
          style={{
            borderColor: color,
            backgroundColor: transparentize(color, secondaryColorOpacity)
          }}
        >
          <Section className={styles.section} contentClassName={styles.content}>
            <div className={styles.header}>
              <h3 style={{ color }} className={styles.title}>
                {title}
              </h3>
              <NotifyLink url={url} ticket={ticket}>
                <Image {...brandImage} {...logoDimensions} className={styles.logo} />
              </NotifyLink>
            </div>
            <div className={styles.products}>
              {products.map((product, index) => (
                <ProductCard
                  ref={node => setElementRef({ ref: node, payload: product })}
                  onLinkClick={() => gtmOnProductClick(product, index)}
                  {...product}
                  key={product.productId}
                  hideVariants
                  picture={pictureDimensions}
                  isSponsoredByListView
                  isListView
                  isCategoryBold
                  customSizes={sizes}
                />
              ))}
            </div>
          </Section>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
